(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["animal1-cursor"] && !Shopify.designMode) return;
  try {
    (() => {
    const canvas = document.querySelector('[data-animal1-cursor-canvas]');
    const stage = document.querySelector('[data-animal1-stage]');
    const follow = document.querySelector('[data-animal1-follow]');
    const animal1Root = document.querySelector('[data-animal1-root]');

    if (!canvas || !stage || !follow || !animal1Root) return;

    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const coarsePointerQuery = window.matchMedia('(pointer: coarse)');
    const shouldRunEffect = () => !reducedMotionQuery.matches && !coarsePointerQuery.matches;
    if (!shouldRunEffect()) return;
    const mainContent = document.getElementById('MainContent');
    const templateName = mainContent?.dataset?.template || '';
    const isProductTemplate = templateName.includes('product');
    const isNotreHistoirePage =
      templateName.includes('page.notre-histoire') ||
      Boolean(document.getElementById('notre-histoire')) ||
      Boolean(document.querySelector('.orion-style-callout'));
    const excludedZoneSelector = [
      '[data-orion-reviews]',
      '.orion-reviews',
      '[data-orion-trustpilot]',
      '.orion-trustpilot',
      ...(isNotreHistoirePage ? ["[id$='__orion_story_slider']"] : []),
    ].join(',');
    const activeZoneSelector = isNotreHistoirePage
      ? [
          '#MainContent',
          '#notre-histoire',
          '.orion-storytelling',
          '.notre-essence',
          '.orion-style-callout',
          '.orion-style-callout-static',
          'footer',
          '#footer-group',
          '.shopify-section-group-footer-group',
          '.shopify-section-group-footer-group .section',
          '.shopify-section-group-footer-group .section-background',
          '.footer-content.spacing-style',
          '.footer-content',
          '.email-signup-block',
          '.email-signup__form',
          '.email-signup__input-group',
        ].join(',')
      : [
          '.product-video-banner--bottom-page .product-video-banner__cursor-zone',
          '.product-video-banner__quote-wrap',
          '.product-video-banner__quote-content',
          '.product-video-banner__quote-button',
          'footer',
          '#footer-group',
          '.shopify-section-group-footer-group',
          '.shopify-section-group-footer-group .section',
          '.shopify-section-group-footer-group .section-background',
          '.footer-content.spacing-style',
          '.footer-content',
          '.email-signup-block',
          '.email-signup__form',
          '.email-signup__input-group',
        ].join(',');
    if (!isProductTemplate && !isNotreHistoirePage) return;

    const ctx = canvas.getContext('2d', { alpha: true });
    if (!ctx) return;

    const BALL_SIZE = 15;
    const BALL_FOLLOW_EASE = 0.11;
    const BALL_PULSE_AMPLITUDE = 1.1;
    const BALL_ROTATION_SPEED = 0.03;
    const DOG_SCALE = 1.04;
    const DOG_SPEED = 6.6;
    const DOG_TURN_SPEED = 0.16;
    const DOG_DAMPING = 0.84;
    const DOG_STOP_DISTANCE = 38;
    const DOG_STEP_FREQUENCY = 0.068;
    const ANIMAL1_Y_OFFSET = 20;
    const MAX_DEVICE_PIXEL_RATIO = 2;
    const breed = {
      body: 1.02,
      height: 1.02,
      follow: 1.0,
    };

    const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

    const size = { width: 1, height: 1, dpr: 1 };
    const pointer = { targetX: window.innerWidth * 0.5, targetY: window.innerHeight * 0.5, active: false };
    const ball = {
      x: pointer.targetX,
      y: pointer.targetY,
      radius: BALL_SIZE,
      rotation: 0,
      pulsePhase: 0,
      floatPhase: 0,
    };
    const dog = {
      x: pointer.targetX - 120,
      y: pointer.targetY + 30,
      vx: 0,
      vy: 0,
      targetX: pointer.targetX - 120,
      targetY: pointer.targetY + 30,
      speed: 0,
      direction: 0,
      dir: 1,
      bobPhase: 0,
    };

    let running = false;
    let rafId = 0;
    let lastTime = performance.now();
    let effectVisible = false;

    const resizeCanvas = () => {
      size.width = Math.max(1, window.innerWidth || 1);
      size.height = Math.max(1, window.innerHeight || 1);
      size.dpr = Math.min(window.devicePixelRatio || 1, MAX_DEVICE_PIXEL_RATIO);
      canvas.width = Math.max(1, Math.round(size.width * size.dpr));
      canvas.height = Math.max(1, Math.round(size.height * size.dpr));
      canvas.style.width = `${size.width}px`;
      canvas.style.height = `${size.height}px`;
      ctx.setTransform(size.dpr, 0, 0, size.dpr, 0, 0);
    };

    const setEffectVisible = (visible) => {
      effectVisible = visible;
      document.documentElement.classList.toggle('animal1-cursor-active', visible);
      canvas.classList.toggle('is-visible', visible);
      stage.classList.toggle('is-visible', visible);
    };

    const setDomOutlineMode = (enabled) => {
      animal1Root.classList.toggle('shadow-mode', enabled);
    };

    const updateBall = (dt) => {
      const targetX = pointer.active ? pointer.targetX : size.width * 0.5;
      const targetY = pointer.active ? pointer.targetY : size.height * 0.5;
      const followEase = 1 - Math.pow(1 - BALL_FOLLOW_EASE, dt);
      ball.x += (targetX - ball.x) * followEase;
      ball.y += (targetY - ball.y) * followEase;
      ball.rotation += BALL_ROTATION_SPEED * dt;
      ball.pulsePhase += 0.08 * dt;
      ball.floatPhase += 0.045 * dt;
    };

    const updateDog = (dt) => {
      const toBallX = ball.x - dog.x;
      const toBallY = ball.y - dog.y;
      const toBallDist = Math.hypot(toBallX, toBallY);

      const desiredDirection = Math.atan2(toBallY, toBallX);
      const angleDelta = Math.atan2(
        Math.sin(desiredDirection - dog.direction),
        Math.cos(desiredDirection - dog.direction)
      );

      const turnEase = 1 - Math.pow(1 - DOG_TURN_SPEED, dt);
      dog.direction += angleDelta * turnEase;

      const desiredDir = Math.cos(dog.direction) >= 0 ? 1 : -1;
      dog.dir += (desiredDir - dog.dir) * turnEase;

      const bodyOffset = (78 + dog.speed * 16) * DOG_SCALE * breed.follow;
      const pursuitOffsetX = Math.cos(desiredDirection) * bodyOffset;
      const pursuitOffsetY = Math.sin(desiredDirection) * (9 + breed.follow * 2) * DOG_SCALE;
      dog.targetX = ball.x - pursuitOffsetX;
      dog.targetY = ball.y + (20 + breed.height * 2) * DOG_SCALE - pursuitOffsetY * 0.45;

      const toTargetX = dog.targetX - dog.x;
      const toTargetY = dog.targetY - dog.y;
      const targetDist = Math.hypot(toTargetX, toTargetY);
      const targetNX = targetDist > 0.0001 ? toTargetX / targetDist : 0;
      const targetNY = targetDist > 0.0001 ? toTargetY / targetDist : 0;

      const stopDistance = DOG_STOP_DISTANCE * breed.follow;
      const slowRadius = stopDistance + 100 * DOG_SCALE * breed.follow;
      const speedFactor = clamp(
        (targetDist - stopDistance) / Math.max(1, slowRadius - stopDistance),
        0,
        1
      );

      const maxSpeed = DOG_SPEED;
      const desiredSpeed = maxSpeed * speedFactor;
      const desiredVX = targetNX * desiredSpeed;
      const desiredVY = targetNY * desiredSpeed;

      const velocityEase = 1 - Math.pow(0.8, dt);
      dog.vx += (desiredVX - dog.vx) * velocityEase;
      dog.vy += (desiredVY - dog.vy) * velocityEase;
      dog.vx *= Math.pow(DOG_DAMPING, dt);
      dog.vy *= Math.pow(DOG_DAMPING, dt);

      let velocityMagnitude = Math.hypot(dog.vx, dog.vy);
      if (velocityMagnitude > maxSpeed) {
        const speedScale = maxSpeed / velocityMagnitude;
        dog.vx *= speedScale;
        dog.vy *= speedScale;
        velocityMagnitude = maxSpeed;
      }

      dog.x += dog.vx * dt;
      dog.y += dog.vy * dt;

      const speedNormTarget = maxSpeed > 0 ? velocityMagnitude / maxSpeed : 0;
      dog.speed += (speedNormTarget - dog.speed) * (1 - Math.pow(0.84, dt));
      dog.bobPhase += DOG_STEP_FREQUENCY * (0.55 + dog.speed * 1.05) * dt;

      if (toBallDist < stopDistance && velocityMagnitude < 0.02) {
        dog.vx = 0;
        dog.vy = 0;
      }
    };

    const updateAnimal1DomFollower = () => {
      const speed = clamp(dog.speed, 0, 1);
      const facing = dog.dir >= 0 ? 1 : -1;
      const x = dog.x;
      const y = dog.y + 24 * DOG_SCALE * breed.height + ANIMAL1_Y_OFFSET;
      const bob = Math.sin(dog.bobPhase * 0.95) * (0.7 + speed * 1.1);
      const scale = DOG_SCALE * breed.body * 0.37;
      const sx = facing * scale * (1 - speed * 0.014);
      const sy = scale * (1 + speed * 0.02);

      follow.style.transform =
        `translate(${x}px, ${y + bob}px) translate(-50%, -84%) scale(${sx}, ${sy})`;

      setDomOutlineMode(true);
      animal1Root.style.setProperty('--a1-duration', `${clamp(0.8 - speed * 0.42, 0.36, 0.8)}s`);
      const wasMoving = animal1Root.classList.contains('is-moving');
      const movingThreshold = wasMoving ? 0.05 : 0.09;
      animal1Root.classList.toggle('is-moving', speed > movingThreshold);
    };

    const drawBall = () => {
      const pulse = 1 + Math.sin(ball.pulsePhase) * (BALL_PULSE_AMPLITUDE / BALL_SIZE);
      const radius = ball.radius * pulse;
      const floatOffsetY = Math.sin(ball.floatPhase) * 1.1;
      const drawX = ball.x;
      const drawY = ball.y + floatOffsetY;

      ctx.lineWidth = 1.18;
      ctx.strokeStyle = 'rgba(20, 20, 20, 0.68)';
      ctx.beginPath();
      ctx.arc(drawX, drawY, radius, 0, Math.PI * 2);
      ctx.stroke();

      ctx.strokeStyle = 'rgba(20, 20, 20, 0.42)';
      ctx.beginPath();
      ctx.ellipse(drawX, drawY, radius, radius * 0.52, ball.rotation, 0, Math.PI * 2);
      ctx.stroke();

      ctx.beginPath();
      ctx.ellipse(drawX, drawY, radius * 0.56, radius, ball.rotation + Math.PI * 0.5, 0, Math.PI * 2);
      ctx.stroke();

      ctx.strokeStyle = 'rgba(20, 20, 20, 0.24)';
      ctx.beginPath();
      ctx.arc(drawX, drawY, radius * 0.72, ball.rotation * 0.65, ball.rotation * 0.65 + Math.PI * 1.25);
      ctx.stroke();
    };

    const frame = (now) => {
      if (!running) return;
      const dt = clamp((now - lastTime) / 1000, 0.001, 0.05) * 60;
      lastTime = now;

      if (!effectVisible) {
        ctx.clearRect(0, 0, size.width, size.height);
        rafId = requestAnimationFrame(frame);
        return;
      }

      updateBall(dt);
      updateDog(dt);
      updateAnimal1DomFollower();

      ctx.clearRect(0, 0, size.width, size.height);
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      drawBall();

      rafId = requestAnimationFrame(frame);
    };

    const startLoop = () => {
      if (running) return;
      running = true;
      lastTime = performance.now();
      rafId = requestAnimationFrame(frame);
    };

    const stopLoop = () => {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = 0;
      ctx.clearRect(0, 0, size.width, size.height);
      animal1Root.classList.remove('is-moving');
      setEffectVisible(false);
    };

    const onPointerMove = (event) => {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      const inExcludedZone = excludedZoneSelector && Boolean(event.target?.closest(excludedZoneSelector));
      const inActiveZone = !inExcludedZone && Boolean(event.target?.closest(activeZoneSelector));
      setEffectVisible(inActiveZone);
      if (!inActiveZone) {
        pointer.active = false;
        animal1Root.classList.remove('is-moving');
        ctx.clearRect(0, 0, size.width, size.height);
        return;
      }
      pointer.targetX = event.clientX;
      pointer.targetY = event.clientY;
      pointer.active = true;
    };

    const onPointerLeave = () => {
      pointer.active = false;
      setEffectVisible(false);
      animal1Root.classList.remove('is-moving');
      ctx.clearRect(0, 0, size.width, size.height);
    };

    const applyRuntimePolicy = () => {
      if (!shouldRunEffect()) {
        stopLoop();
        canvas.style.display = 'none';
        stage.style.display = 'none';
        return;
      }

      canvas.style.display = 'block';
      stage.style.display = 'block';
      resizeCanvas();
      startLoop();
    };

    window.addEventListener('resize', resizeCanvas, { passive: true });
    window.addEventListener('pointermove', onPointerMove, { passive: true });
    window.addEventListener('pointerleave', onPointerLeave, { passive: true });
    reducedMotionQuery.addEventListener('change', applyRuntimePolicy);
    coarsePointerQuery.addEventListener('change', applyRuntimePolicy);

    applyRuntimePolicy();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["orion-product-trust-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobileQuery = window.matchMedia('(max-width: 549px)');
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const bars = document.querySelectorAll('.orion-product-trust-bar');

    bars.forEach((bar) => {
      if (bar.dataset.carouselReady === 'true') return;
      bar.dataset.carouselReady = 'true';

      const track = bar.querySelector('.orion-product-trust-bar__inner');
      const items = Array.from(bar.querySelectorAll('.orion-product-trust-bar__item'));
      const dots = Array.from(bar.querySelectorAll('.orion-product-trust-bar__dot'));
      let activeIndex = 0;
      let timer;
      let scrollTimer;
      let leadingClone;
      let trailingClone;

      const setActive = (index) => {
        activeIndex = Math.max(0, Math.min(index, items.length - 1));
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const scrollLeftFor = (index) => {
        return (index + 1) * Math.max(track.clientWidth, 1);
      };

      const jumpTo = (index) => {
        if (!track) return;
        track.classList.add('is-jumping');
        track.scrollTo({ left: scrollLeftFor(index), behavior: 'auto' });
        setActive(index);
        window.requestAnimationFrame(() => {
          track.classList.remove('is-jumping');
        });
      };

      const ensureLoop = () => {
        if (!mobileQuery.matches || !track || items.length < 2) return;
        if (!leadingClone || !trailingClone) {
          leadingClone = items[items.length - 1].cloneNode(true);
          trailingClone = items[0].cloneNode(true);
          leadingClone.setAttribute('aria-hidden', 'true');
          trailingClone.setAttribute('aria-hidden', 'true');
          leadingClone.dataset.carouselClone = 'true';
          trailingClone.dataset.carouselClone = 'true';
          track.insertBefore(leadingClone, items[0]);
          track.appendChild(trailingClone);
        }

        window.requestAnimationFrame(() => jumpTo(activeIndex));
      };

      const removeLoop = () => {
        leadingClone?.remove();
        trailingClone?.remove();
        leadingClone = null;
        trailingClone = null;
        track?.scrollTo({ left: 0, behavior: 'auto' });
      };

      const goTo = (index) => {
        if (!mobileQuery.matches || !track || !items[index]) return;
        ensureLoop();
        track.scrollTo({
          left: scrollLeftFor(index),
          behavior: reduceMotionQuery.matches ? 'auto' : 'smooth',
        });
        setActive(index);
      };

      const start = () => {
        clearInterval(timer);
        if (!mobileQuery.matches) {
          removeLoop();
          return;
        }

        if (!leadingClone || !trailingClone) {
          ensureLoop();
        }
        if (reduceMotionQuery.matches || items.length < 2) return;
        timer = setInterval(() => {
          goTo((activeIndex + 1) % items.length);
        }, 10000);
      };

      const updateFromScroll = () => {
        if (!mobileQuery.matches || !track || !leadingClone || !trailingClone) return;
        const rawIndex = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        let index = rawIndex - 1;
        if (rawIndex === 0) {
          index = items.length - 1;
        } else if (rawIndex === items.length + 1) {
          index = 0;
        }
        setActive(index);
      };

      const settleLoop = () => {
        if (!mobileQuery.matches || !track || !leadingClone || !trailingClone) return;
        const rawIndex = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (rawIndex === 0) {
          jumpTo(items.length - 1);
        } else if (rawIndex === items.length + 1) {
          jumpTo(0);
        }
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          goTo(index);
          start();
        });
      });

      track?.addEventListener('scroll', () => {
        window.requestAnimationFrame(updateFromScroll);
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(settleLoop, 120);
      }, { passive: true });

      track?.addEventListener('pointerdown', () => {
        clearInterval(timer);
      }, { passive: true });

      track?.addEventListener('pointerup', () => {
        settleLoop();
        start();
      }, { passive: true });
      mobileQuery.addEventListener('change', () => {
        if (mobileQuery.matches) {
          start();
        } else {
          clearInterval(timer);
          removeLoop();
        }
      });
      reduceMotionQuery.addEventListener('change', start);

      setActive(0);
      start();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["premium-living-cursor"] && !Shopify.designMode) return;
  try {
    (() => {
    const canUseCustomCursor =
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!canUseCustomCursor) return;

    const root = document.documentElement;
    const cursor = document.querySelector('[data-premium-living-cursor]');
    const orb = cursor?.querySelector('[data-premium-living-cursor-orb]');
    const dog = cursor?.querySelector('[data-premium-living-cursor-dog]');
    const orbHalo = orb?.querySelector('.premium-living-cursor__orb-halo');

    if (!cursor || !orb || !dog || !orbHalo) return;

    const customConfig = window.OrionPremiumCursorConfig || {};
    const config = {
      orbSize: 22,
      orbScaleHover: 1.12,
      orbScaleDown: 0.94,
      orbEase: 0.28,
      dogEase: 0.24,
      dogOffset: 19,
      dogOffsetHover: 15,
      dogVerticalOffset: 2,
      dogOpacityIdleBoost: 0,
      idleDelay: 1200,
      idleIntensity: 0.3,
      tailSwing: 4.5,
      headLift: 2,
      bodyBob: 0.8,
      ...customConfig,
    };
    const baseDogOpacity = Number(getComputedStyle(root).getPropertyValue('--premium-cursor-dog-opacity')) || 0.56;

    orb.style.setProperty('--premium-cursor-orb-size', `${config.orbSize}px`);

    const state = {
      active: false,
      visible: false,
      textMode: false,
      hoveringInteractive: false,
      pressed: false,
      mouseX: window.innerWidth * 0.5,
      mouseY: window.innerHeight * 0.5,
      orbX: window.innerWidth * 0.5,
      orbY: window.innerHeight * 0.5,
      dogX: window.innerWidth * 0.5,
      dogY: window.innerHeight * 0.5,
      directionX: 1,
      velocity: 0,
      runCycle: 0,
      lastMoveAt: performance.now(),
      wasIdle: false,
      idleModeIndex: 0,
      idleMode: 'tail',
    };

    const interactiveSelector = [
      'a[href]',
      'button',
      '[role="button"]',
      'summary',
      'label[for]',
      'input[type="submit"]',
      'input[type="button"]',
      '.button',
      '.btn',
    ].join(',');

    const textSelector = [
      'textarea',
      'select',
      'input:not([type="submit"]):not([type="button"]):not([type="checkbox"]):not([type="radio"]):not([type="range"])',
      '[contenteditable="true"]',
    ].join(',');

    const idleModes = ['tail', 'head', 'sit'];

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const lerp = (start, end, ease) => start + (end - start) * ease;

    const setVisibility = (visible) => {
      state.visible = visible;
      cursor.classList.toggle('is-visible', visible && !state.textMode);
    };

    const setTextMode = (enabled) => {
      state.textMode = enabled;
      root.classList.toggle('premium-living-cursor-text-mode', enabled);
      cursor.classList.toggle('is-visible', state.visible && !enabled);
    };

    const updateTargetContext = (target) => {
      const textTarget = target?.closest(textSelector);
      setTextMode(Boolean(textTarget));

      const interactiveTarget = target?.closest(interactiveSelector);
      state.hoveringInteractive = Boolean(interactiveTarget) && !textTarget;
    };

    const onPointerMove = (event) => {
      if (event.pointerType && event.pointerType !== 'mouse') return;

      state.active = true;
      state.mouseX = event.clientX;
      state.mouseY = event.clientY;
      state.lastMoveAt = performance.now();

      if (Math.abs(event.movementX) > 0.02) {
        state.directionX = event.movementX > 0 ? 1 : -1;
      }

      updateTargetContext(event.target);
      setVisibility(true);
    };

    const onPointerLeave = () => {
      setVisibility(false);
      state.hoveringInteractive = false;
      state.pressed = false;
    };

    const onPointerDown = () => {
      state.pressed = true;
    };

    const onPointerUp = () => {
      state.pressed = false;
    };

    root.classList.add('premium-living-cursor-enabled');

    window.addEventListener('pointermove', onPointerMove, { passive: true });
    window.addEventListener('pointerdown', onPointerDown, { passive: true });
    window.addEventListener('pointerup', onPointerUp, { passive: true });
    window.addEventListener('pointerleave', onPointerLeave, { passive: true });
    window.addEventListener('blur', onPointerLeave);

    const renderFrame = (now) => {
      // Keep the orb close to the pointer while the dog trails behind with a softer cadence.
      const deltaX = state.mouseX - state.orbX;
      const deltaY = state.mouseY - state.orbY;
      const distance = Math.hypot(deltaX, deltaY);

      state.velocity = lerp(state.velocity, distance, 0.12);
      state.orbX = lerp(state.orbX, state.mouseX, config.orbEase);
      state.orbY = lerp(state.orbY, state.mouseY, config.orbEase);

      const runningAmount = clamp(state.velocity / 42, 0, 1);
      const inactivity = now - state.lastMoveAt;
      const isIdle = state.active && inactivity > config.idleDelay && state.velocity < 0.35;

      if (isIdle) {
        if (!state.wasIdle) {
          state.idleModeIndex = (state.idleModeIndex + 1) % idleModes.length;
          state.idleMode = idleModes[state.idleModeIndex];
        }
      } else {
        state.idleMode = idleModes[state.idleModeIndex];
      }
      state.wasIdle = isIdle;

      state.runCycle += 0.06 + runningAmount * 0.18;

      const dogDistance = state.hoveringInteractive ? config.dogOffsetHover : config.dogOffset;
      const dogTargetX = state.orbX - state.directionX * dogDistance;
      const dogTargetY =
        state.orbY +
        config.dogVerticalOffset +
        Math.sin(state.runCycle) * config.bodyBob * (0.15 + runningAmount * 0.85);

      state.dogX = lerp(state.dogX, dogTargetX, config.dogEase + (state.hoveringInteractive ? 0.03 : 0));
      state.dogY = lerp(state.dogY, dogTargetY, config.dogEase);

      let orbScale = 1;
      if (state.hoveringInteractive) orbScale = config.orbScaleHover;
      if (state.pressed) orbScale *= config.orbScaleDown;

      const hoverHalo = state.hoveringInteractive ? 1.18 : 1;
      const headRotateRun = Math.sin(state.runCycle + 0.4) * (1.6 + runningAmount * 2.2);
      const tailRotateRun = Math.sin(state.runCycle + 1.4) * (2.8 + runningAmount * config.tailSwing);
      const bodyLiftRun = Math.sin(state.runCycle) * config.bodyBob * (0.2 + runningAmount * 0.8);

      let idleHead = 0;
      let idleTail = 0;
      let idleLift = 0;
      let idleCompress = 1;

      if (isIdle) {
        const idleTime = (inactivity - config.idleDelay) * 0.0012;
        const idleWave = Math.sin(idleTime);
        const intensity = config.idleIntensity;

        if (state.idleMode === 'tail') {
          idleTail = idleWave * config.tailSwing * 0.55 * intensity;
          idleHead = Math.sin(idleTime * 0.5) * 1.5 * intensity;
        } else if (state.idleMode === 'head') {
          idleHead = (Math.sin(idleTime * 0.7) * config.headLift + 1.8) * intensity;
          idleLift = Math.sin(idleTime * 0.35) * 1.3 * intensity;
        } else {
          idleLift = 2.4 * intensity;
          idleCompress = 1 - 0.04 * intensity + Math.sin(idleTime * 0.5) * 0.01;
          idleTail = Math.sin(idleTime * 0.8) * 2.8 * intensity;
        }
      }

      orb.style.transform = `translate3d(${state.orbX}px, ${state.orbY}px, 0) scale(${orbScale})`;
      dog.style.transform = `translate3d(${state.dogX}px, ${state.dogY}px, 0) scaleX(${state.directionX})`;
      dog.style.opacity = `${clamp(baseDogOpacity + (isIdle ? config.dogOpacityIdleBoost : 0), 0, 1)}`;

      cursor.style.setProperty('--premium-cursor-head-rotate', `${headRotateRun - idleHead}deg`);
      cursor.style.setProperty('--premium-cursor-tail-rotate', `${tailRotateRun + idleTail}deg`);
      cursor.style.setProperty('--premium-cursor-dog-lift', `${-bodyLiftRun - idleLift}px`);
      cursor.style.setProperty('--premium-cursor-dog-compress', `${idleCompress}`);
      orbHalo.style.opacity = `${0.55 * hoverHalo}`;

      window.requestAnimationFrame(renderFrame);
    };

    window.requestAnimationFrame(renderFrame);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    function initializeVariantPickerAdoptButtons() {
    document.querySelectorAll('[data-variant-picker-adopt]').forEach((button) => {
      if (button.dataset.adoptReady === 'true') return;
      button.dataset.adoptReady = 'true';

      button.addEventListener('click', async () => {
        const picker = button.closest('variant-picker');
        const productDetails = button.closest('.product-details');
        const variantInput =
          productDetails?.querySelector('product-form-component input[name="id"]') ||
          document.querySelector('product-form-component input[name="id"]');
        const selectedInput = picker?.querySelector('input[type="radio"]:checked[data-variant-id]');
        const selectedOption = picker?.querySelector('select option:checked[data-variant-id]');
        const variantId = variantInput?.value || selectedInput?.dataset.variantId || selectedOption?.dataset.variantId;

        if (!variantId) {
          window.location.href = '/cart';
          return;
        }

        button.disabled = true;

        try {
          const root =
            window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/';

          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: [
                {
                  id: Number(variantId),
                  quantity: 1,
                },
              ],
            }),
          });

          if (!response.ok) throw new Error('Cart add failed');

          const currentUrl = new URL(window.location.href);
          const cartUrl = new URL(`${window.location.origin}${root}cart`);
          ['preview_theme_id', '_fd', 'pb'].forEach((param) => {
            const value = currentUrl.searchParams.get(param);
            if (value) cartUrl.searchParams.set(param, value);
          });

          window.location.href = cartUrl.toString();
        } catch (error) {
          window.location.href = '/cart';
        } finally {
          button.disabled = false;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeVariantPickerAdoptButtons);
  } else {
    initializeVariantPickerAdoptButtons();
  }
  } catch(e) { console.error(e); }
})();

})();
